// extracted by mini-css-extract-plugin
export default {"wrapper":"access_requests-module___wrapper___eea6fb58","notFound":"access_requests-module___notFound___e4e5a413","status":"access_requests-module___status___aff0df9d"};